import { render, staticRenderFns } from "./template_market.vue?vue&type=template&id=7fd577f2&scoped=true&"
import script from "./template_market.vue?vue&type=script&lang=js&"
export * from "./template_market.vue?vue&type=script&lang=js&"
import style0 from "./template_market.vue?vue&type=style&index=0&id=7fd577f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd577f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fd577f2')) {
      api.createRecord('7fd577f2', component.options)
    } else {
      api.reload('7fd577f2', component.options)
    }
    module.hot.accept("./template_market.vue?vue&type=template&id=7fd577f2&scoped=true&", function () {
      api.rerender('7fd577f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/open3d/template_market.vue"
export default component.exports